var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacilityIcon32(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_442",
    "data-name": "Group 442",
    transform: "translate(-1418 -4069)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(1418 4069)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8_elevator",
    d: "M12,2,9,5h6Zm5,0,3,3,3-3ZM4,8V29H28V8Zm2,2H26V27H6Zm5.5,1a2.487,2.487,0,0,0-1.594,4.406A3.5,3.5,0,0,0,8,18.5V22H9v4h2V20H10V18.5a1.5,1.5,0,0,1,3,0V20H12v6h2V22h1V18.5a3.5,3.5,0,0,0-1.906-3.094A2.487,2.487,0,0,0,11.5,11Zm9,0a2.487,2.487,0,0,0-1.594,4.406A3.5,3.5,0,0,0,17,18.5V22h1v4h2V20H19V18.5a1.5,1.5,0,0,1,3,0V20H21v6h2V22h1V18.5a3.5,3.5,0,0,0-1.906-3.094A2.487,2.487,0,0,0,20.5,11Zm-9,2a.5.5,0,1,1-.5.5A.484.484,0,0,1,11.5,13Zm9,0a.5.5,0,1,1-.5.5A.484.484,0,0,1,20.5,13Z",
    transform: "translate(1432 4084)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilityIcon32);
export default __webpack_public_path__ + "static/media/facilityIcon32.dfa8b1f8e1429fc82cf540667b20af28.svg";
export { ForwardRef as ReactComponent };